import { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import "../../../style/setup.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

export const CompletenessCheckModal = ({
  open,
  onClose,
  accessToken,
  currentPeriod
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");

  const [dataCellStoreMapping, setDataCellStoreMapping] = useState([]);

  async function fetchMainData() {
    setDataCellStoreMapping([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);
    queryParams.append("period", currentPeriod);
    queryParams.append("category", "by_completeness_check");

    const queryString = queryParams.toString();
    const apiUrl =
      `${
        process.env.REACT_APP_API_URL
      }/api/v1/data-processing-raw/rta_mt/retailer/check` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setDataCellStoreMapping(data.data);
      } else if (response.status === 404) {
        setDataCellStoreMapping([]);
      } else {
        setDataCellStoreMapping([]);
      }
    } catch (error) {
      setDataCellStoreMapping([]);
    }

    setIsLoading(false);
  }

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (currentPeriod) {
        fetchMainData();
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, currentPeriod, currentPage, itemsPerPage]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setCurrentPage(1);
          onClose();
          setDataCellStoreMapping([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: 0 }}
      >
        <Box sx={{ ...style, maxHeight: "80vh", overflow: "auto", borderRadius: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ flexGrow: 1 }}
            >
              Completeness Check
            </Typography>
            <IconButton
              onClick={() => {
                setCurrentPage(1);
                onClose();
                setDataCellStoreMapping([]);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 650 }}>
                <Table
                  aria-label="simple table"
                  sx={{
                    border: 1,
                    borderColor: "grey.300",
                    borderCollapse: "collapse",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={tableCellStyle}
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        Retailer
                      </TableCell>
                      <TableCell
                        style={tableCellStyle}
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        Remarks
                      </TableCell>
                      {/* <TableCell
                        style={tableCellStyle}
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        Aksi
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataCellStoreMapping.length > 0 ? (
                      dataCellStoreMapping.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell
                            align="center"
                            sx={{ border: 1, borderColor: "grey.300" }}
                          >
                            {row.retailer}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: 1, borderColor: "grey.300" }}
                          >
                            {row.remarks}
                          </TableCell>
                          {/* <TableCell
                            align="center"
                            sx={{ border: 1, borderColor: "grey.300" }}
                          >
                            <Tooltip
                              title="Edit Data"
                              onClick={() =>
                                window.open(
                                  `/data-processing/cell-store-mapping/${row.id}`,
                                  "_blank",
                                  "noopener,noreferrer"
                                )
                              }
                            >
                              <IconButton>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell> */}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={10}
                          align="center"
                          sx={{ border: 1, borderColor: "grey.300" }}
                        >
                          {isLoading ? "Loading..." : "No Data Available"}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* pagination */}
              {dataCellStoreMapping.length > 0 && (
                <TablePagination
                  rowsPerPageOptions={itemsPerPageList}
                  component="div"
                  count={totalItems}
                  rowsPerPage={itemsPerPage}
                  page={currentPage - 1}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleChangeItemPerPageSelect}
                />
              )}
            </Paper>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
